import {Component, Input} from '@angular/core';
import { TaskAttribute } from '../../create-task/create-task.type';

@Component({
   selector: 'app-message-recipients',
   templateUrl: './message-recipients.component.html',
   styleUrls: ['./message-recipients.component.css']
})
export class MessageRecipientsComponent {
   @Input() taskAttribute: TaskAttribute;
   public message;

   constructor() {
      // This is intentional.
   }

}
